import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTraderAuth } from '../context/TraderAuthContext';
import { useTraderTheme } from '../context/TraderThemeContext';
import { useTraderLanguage } from '../context/TraderLanguageContext';
import { useMobileNav } from '../context/MobileNavContext';
import { Home, Wallet, ArrowDownToLine, ArrowUpFromLine, Calendar, HelpCircle, Settings, Upload, Sun, Moon, LogOut, Menu, X } from 'lucide-react';

const TraderSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useTraderAuth();
  const { isDark, toggleTheme } = useTraderTheme();
  const { t, tx } = useTraderLanguage();
  const { sidebarOpen, setSidebarOpen, isMobile, isTablet } = useMobileNav();
  const compact = !isMobile && !isTablet;
  const items = [
    [Home, 'home', '/trader', 'nav.home'], [Wallet, 'funds', '/trader/funds', 'nav.funds'],
    [ArrowDownToLine, 'deposit', '/trader/deposit', 'nav.deposit'], [ArrowUpFromLine, 'withdraw', '/trader/withdraw', 'nav.withdraw'],
    [Calendar, 'calendar', '/trader/calendar', 'nav.economicCalendar'], [HelpCircle, 'help', '/trader/help', 'nav.helpCenter'],
    [Settings, 'settings', '/trader/settings', 'nav.personalSettings'], [Upload, 'documents', '/trader/documents', 'nav.uploadDocuments'],
  ];
  useEffect(() => {
    if (!sidebarOpen) return;
    const close = event => { if (event.key === 'Escape') setSidebarOpen(false); };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, [sidebarOpen, setSidebarOpen]);
  const go = path => { navigate(path); setSidebarOpen(false); };
  const themeLabel = t(isDark ? 'nav.lightMode' : 'nav.darkMode');
  const ThemeIcon = isDark ? Sun : Moon;
  return <>
    {compact && <aside className="mt5-rail" data-testid="trader-navigation-rail" aria-label={tx('Menu')}>
      <button data-testid="desktop-menu-toggle" title={tx('Menu')} aria-label={tx('Menu')} aria-expanded={sidebarOpen} onClick={() => setSidebarOpen(!sidebarOpen)}><Menu size={21}/></button>
      <nav>{items.map(([Icon, id, path, key]) => <button key={id} data-testid={`sidebar-${id}`} title={t(key)} aria-label={t(key)} aria-current={location.pathname === path ? 'page' : undefined} onClick={() => go(path)}><Icon size={20}/></button>)}</nav>
      <button data-testid="sidebar-theme" title={themeLabel} aria-label={themeLabel} onClick={toggleTheme}><ThemeIcon size={20}/></button>
      <button data-testid="sidebar-logout" title={t('nav.logOut')} aria-label={t('nav.logOut')} onClick={logout}><LogOut size={20}/></button>
    </aside>}
    {sidebarOpen && <>
      <button className="mt5-menu-backdrop" data-testid="trader-menu-backdrop" aria-label={tx('Close')} onClick={() => setSidebarOpen(false)}/>
      <aside className="mt5-menu" data-testid="trader-navigation-menu" aria-label={tx('Menu')}>
        <header><strong>{tx('Menu')}</strong><button data-testid="trader-menu-close" aria-label={tx('Close')} onClick={() => setSidebarOpen(false)}><X size={20}/></button></header>
        <nav>{items.map(([Icon, id, path, key]) => <button key={id} data-testid={compact ? `menu-${id}` : `sidebar-${id}`} aria-current={location.pathname === path ? 'page' : undefined} onClick={() => go(path)}><Icon size={19}/><span>{t(key)}</span></button>)}</nav>
        <footer>
          <button data-testid={compact ? 'menu-theme' : 'sidebar-theme'} onClick={toggleTheme}><ThemeIcon size={19}/><span>{themeLabel}</span></button>
          <button data-testid={compact ? 'menu-logout' : 'sidebar-logout'} onClick={logout}><LogOut size={19}/><span>{t('nav.logOut')}</span></button>
        </footer>
      </aside>
    </>}
  </>;
};
export default TraderSidebar;